export default __webpack_public_path__ + "static/O0312-a7c91c57c25c052910a1cf7f266a485b.png";